import { render } from "./VirtualScroll.vue?vue&type=template&id=8e09d848&scoped=true"
import script from "./VirtualScroll.vue?vue&type=script&lang=js"
export * from "./VirtualScroll.vue?vue&type=script&lang=js"

import "./VirtualScroll.vue?vue&type=style&index=0&id=8e09d848&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e09d848"

export default script